export const ADD_TODO = 'ADD_TODO';
export const UPDATE_TODO = 'UPDATE_TODO';
export const DELETE_TODO = 'DELETE_TODO';
export const TOGGLE_DONE_TODO = 'TOGGLE_DONE_TODO';
export const SET_FILTER_TODOS = 'SET_FILTER_TODOS';
export const SHOW_ALL_TODOS = 'SHOW_ALL';
export const SHOW_ACTIVE_TODOS = 'SHOW_ACTIVE';
export const SHOW_COMPLETED_TODOS = 'SHOW_COMPLETED';
